import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { IOrder } from '../../../../interfaces/order';
import { actions as orderActions } from '../../../../store/ducks/orders.duck';

export const getInitialValuesOrderPage = (order: IOrder) => {
  const subOrder = order?.orders?.[0];
  const values: any = {
    uuid: order.uuid,
    fio: order.main_order ? order.main_order.fio || '' : order.fio || '',
    city: order.city || '',
    region: order.region || '',
    street: order.street || '',
    home: order.home || '',
    flat: order.flat || '',
    entrance: order.entrance || '',
    building: order.building || '',
    phone: order.main_order ? order.main_order.phone || '' : order.phone || '',
    comment: order.comment || '',
    status: order.status || 'payed',
    email: order.email || '',
    payment_status: order.payment_status || 'not_paid',
    deliveryType: order.delivery_type || '-',
    receivedAtString: order.received_at,
    items: [],
    timetable: order.delivery_point?.timetable || '',
    description: order.delivery_point?.description || '',
    code: order.delivery_point?.code || '',
    addressCDEKCity: order.point?.city_name|| '',
    pointCode: order.point?.cdek_code || '',
    address: order.city?.length > 0 ? `${order.city}, ${order.address}` : order.address,
    location: order.location,
    delivery_date: order.delivery_date,
    delivery_date_string: order.delivery_date,
    delivery_type: order.delivery_type || '',
    store: subOrder?.store || undefined,
  };
  if (order.main_order) {
    order.items.forEach(item => {
      values.items.push({ ...item, product_id: item?.product.id! });
    });
  } else {
    order.orders &&
      order.orders.forEach(item => {
        item.items.map(e => values.items.push({ ...e, product_id: e?.product.id! }));
      });
  }
  return values;
};

export const useFormikOrderPage = ({ order, id }: { order?: IOrder; id: string }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: order ? getInitialValuesOrderPage(order) : {},
    validationSchema: Yup.object().shape({
      phone: Yup.string()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .nullable(),
      fio: Yup.string()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .nullable(),
    }),
    onSubmit: submitValues => {
      dispatch(
        orderActions.editRequest({
          id: +id,
          data: {
            ...submitValues,
            storeId: order?.company ? submitValues.store?.id : undefined,
          },
        })
      );
      const subOrder = order?.orders?.[0];
      if (subOrder && subOrder.company) {
        const items = subOrder.items.map(item => {
          return {
            ...item,
            product_id: item.product.id!,
          };
        });
        dispatch(
          orderActions.editRequest({
            id: subOrder.id,
            data: {
              status: subOrder.status,
              items,
              storeId: subOrder.company ? submitValues.store?.id : undefined,
            },
          })
        );
      }
    },
  });

  return formik;
};
